import React from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import FormAsyncSelectField from '../../common/components/formFields/FormAsyncSelectField';
import { dataToSelect } from '../../common/helpers';
import { getDealers } from '../DealersActions';
import { SET_DEALERS_SELECT_SEARCH_STATE } from '../DealersReducer';

const DealersSelectField = props => {
  const dispatch = useDispatch();

  const loadOptions = _.debounce((inputValue, callback) => {
    dispatch(
      getDealers(inputValue, dealers => {
        const selectData = dataToSelect(dealers?.data?.content, ['id', 'tradeName']);
        dispatch({
          type: SET_DEALERS_SELECT_SEARCH_STATE,
          payload: selectData,
        });
        callback(selectData);
      }),
    );
    return true;
  }, 500);

  return <FormAsyncSelectField {...props} loadOptions={loadOptions} defaultOptions />;
};

DealersSelectField.propTypes = {};

export default DealersSelectField;
